import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Fetches every message we sent a member, newest first — pet-specific ones included,
 * since the member page is the account-level view of what a client was told.
 */
export function useListMemberCommunications(memberId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['member-communications', memberId],
    queryFn: async () => {
      const response = await api.get('/communications', { query: { memberId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.communications
    },
  })
}
